import * as React from 'react';
import { FC, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import stylesheet, { blue } from 'src/constants/stylesheet';
import GoogleMaps from './GoogleMap';
import { GOOGLE_MAP_KEY } from 'src/constants/consttants';
import spacing from 'src/constants/spacing';
import mediaQueries from 'src/constants/responsive';
import { useApi } from 'src/@context/Api';

const useStyles = makeStyles(() =>
	createStyles({
		root: {},
		mapSection: {
			maxWidth: 1140,
			margin: '0 auto',
			padding: '0 30px',
		},
		mapSectionTitle: {
			...stylesheet.TitleH1,
			padding: '1em 0 .5em 0',
			textAlign: 'center',
		},
		mapSectionMap: {
			position: 'relative',
			height: 0,
			overflow: 'hidden',
			[mediaQueries.Mobile]: {
				paddingBottom: '100%',
				marginBottom: spacing.Gutter.Mobile * 2,
			},
			[mediaQueries.AfterMobile]: {
				paddingBottom: '32.28%',
			},
			[mediaQueries.Tablet]: {
				marginBottom: spacing.Gutter.Tablet * 2,
			},
			[mediaQueries.Laptop]: {
				marginBottom: spacing.Gutter.Laptop * 2,
			},
			[mediaQueries.Desktop]: {
				marginBottom: spacing.Gutter.Desktop * 2,
			},
		},
		hr: {
			...stylesheet.HR,
			// marginBottom: 13,
			// [mediaQueries.Tablet]: {
			//     marginLeft: spacing.Gutter.Tablet / 2,
			//     marginRight: spacing.Gutter.Tablet / 2,
			// },
			// [mediaQueries.Laptop]: {
			//     marginLeft: spacing.Gutter.Laptop / 2,
			//     marginRight: spacing.Gutter.Laptop / 2,
			// },
			// [mediaQueries.Desktop]: {
			//     marginLeft: spacing.Gutter.Desktop / 2,
			//     marginRight: spacing.Gutter.Desktop / 2,
			// },
		},
		mapSectionMapInner: {
			position: 'absolute',
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
		},
		content: {
			maxWidth: spacing.ContentMaxWidt,
			margin: '0 auto',
		},
		columns: {
			display: 'flex',
			flexWrap: 'wrap',

			[mediaQueries.Mobile]: {},
			[mediaQueries.Tablet]: {
				marginLeft: -spacing.Gutter.Tablet / 2,
				marginRight: -spacing.Gutter.Tablet / 2,
				marginBottom: spacing.Gutter.Tablet * 2,
			},
			[mediaQueries.Laptop]: {
				marginLeft: -spacing.Gutter.Laptop / 2,
				marginRight: -spacing.Gutter.Laptop / 2,
				marginBottom: spacing.Gutter.Laptop * 2,
			},
			[mediaQueries.Desktop]: {
				marginLeft: -spacing.Gutter.Desktop / 2,
				marginRight: -spacing.Gutter.Desktop / 2,
				marginBottom: spacing.Gutter.Desktop * 2,
			},
		},
		column: {
			[mediaQueries.Mobile]: {
				width: '100%',
				marginBottom: spacing.Gutter.Mobile * 2,
				textAlign: 'center',
			},
			[mediaQueries.AfterMobile]: {
				width: `${(1 / 3) * 100}%`,
			},
			[mediaQueries.Tablet]: {
				paddingLeft: spacing.Gutter.Tablet / 2,
				paddingRight: spacing.Gutter.Tablet / 2,
			},
			[mediaQueries.Laptop]: {
				paddingLeft: spacing.Gutter.Laptop / 2,
				paddingRight: spacing.Gutter.Laptop / 2,
			},
			[mediaQueries.Desktop]: {
				paddingLeft: spacing.Gutter.Desktop / 2,
				paddingRight: spacing.Gutter.Desktop / 2,
			},
		},
		fromSection: {
			[mediaQueries.Mobile]: {
				padding: '0 30px',
			},

			[mediaQueries.AfterMobile]: {
				maxWidth: spacing.ContentMaxWidt,
				margin: '0 auto',
			},
		},
		form: {
			[mediaQueries.Mobile]: {
				paddingBottom: '5rem',
			},
			[mediaQueries.AfterMobile]: {
				maxWidth: '50%',
				margin: '0 auto 5rem auto',
			},
		},
		formTitle: {
			...stylesheet.TitleH1,
			padding: '1em 0 .5em 0',
			textAlign: 'center',
		},
		formSubtitle: {
			textAlign: 'center',
			marginBottom: '1em',
		},
		label: {
			display: 'block',
			width: '100%',

			[mediaQueries.Mobile]: {
				marginBottom: spacing.Gutter.Tablet,
			},
			[mediaQueries.Tablet]: {
				marginBottom: spacing.Gutter.Tablet,
			},
			[mediaQueries.Laptop]: {
				marginBottom: spacing.Gutter.Laptop,
			},
			[mediaQueries.Desktop]: {
				marginBottom: spacing.Gutter.Desktop,
			},

			'& span': {
				display: 'block',
				textAlign: 'center',
			},

			'$inputError &': {
				color: 'red',
			},
		},
		input: {
			display: 'block',
			width: '100%',
			border: `1px solid ${blue}`,
			borderRadius: 4,
			fontSize: '1rem',
			fontFamily: 'inherit',
			padding: '7px 10px 4px 10px',
			color: blue,

			'$inputError &': {
				borderColor: 'red',
			},
		},
		textarea: {
			display: 'block',
			width: '100%',
			border: `1px solid ${blue}`,
			borderRadius: 4,
			minHeight: 120,
			fontSize: '1rem',
			fontFamily: 'inherit',
			padding: '8px 10px 4px 10px',
			color: blue,
		},
		warnning: {
			color: 'black',
			textAlign: 'center',

			[mediaQueries.Mobile]: {
				marginBottom: spacing.Gutter.Tablet * 2,
			},
			[mediaQueries.Tablet]: {
				marginBottom: spacing.Gutter.Tablet * 2,
			},
			[mediaQueries.Laptop]: {
				marginBottom: spacing.Gutter.Laptop * 2,
			},
			[mediaQueries.Desktop]: {
				marginBottom: spacing.Gutter.Desktop * 2,
			},
		},
		submitButton: {
			display: 'block',
			width: '100%',
			border: 'none',
			backgroundColor: blue,
			color: 'white',
			borderRadius: 4,
			fontSize: '1rem',
			padding: '5px 0',
		},
		errorMessage: {
			padding: '20px 0',
			color: 'red',
		},
		successMessage: {
			padding: '20px 0',
			color: 'green',
		},
		inputError: {},
	})
);

export type ContactProps = ContactDto;
type Props = ContactProps;

const Contact: FC<Props> = ({
	MapTitle,
	Coordinates,
	ColumnTextOne,
	ColumnTextTwo,
	ColumnTextThree,
	FormTitle,
	FormSubtitle,
}) => {
	const cls = useStyles();
	// const [error, setError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [successMessage, setSuccessMessage] = useState('');

	const { app } = useApi();
	const config = app && app.Config;
	const translationsItems = config && config.TranslationItems;
	const salutation =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_salutation');
	const name =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_name');
	const company =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_company');
	const email =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_email');
	const address =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_address');
	const telephone =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_telephone');
	const message =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_message');
	const warnning =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_warnning');
	const sendButton =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_send_button');
	const emailSuccessMessage =
		translationsItems &&
		translationsItems.find((t) => t.UID === 'contact_success_message');

	const salutationRef = React.useRef<HTMLInputElement>(null);
	const nameRef = React.useRef<HTMLInputElement>(null);
	const companyRef = React.useRef<HTMLInputElement>(null);
	const emailRef = React.useRef<HTMLInputElement>(null);
	const addressRef = React.useRef<HTMLInputElement>(null);
	const phoneRef = React.useRef<HTMLInputElement>(null);
	const messageRef = React.useRef<HTMLTextAreaElement>(null);

	const handleSubmit = async (ev: React.FormEvent<HTMLFormElement>) => {
		ev.preventDefault();
		setErrorMessage('');

		const salutationInput = salutationRef.current?.value;
		const nameInput = nameRef.current?.value;
		const companyInput = companyRef.current?.value;
		const emailInput = emailRef.current?.value;
		const addressInput = addressRef.current?.value;
		const phoneInput = phoneRef.current?.value;
		const messageInput = messageRef.current?.value;

		if (!name || !emailInput || !phoneInput) {
			setErrorMessage('Please fill mandatory information');
			return;
		}

		const body = {
			Salutaion: salutationInput || '',
			Name: nameInput || '',
			EMail: emailInput || '',
			Company: companyInput || '',
			Address: addressInput || '',
			Phone: phoneInput || '',
			Message: messageInput || '',
		};

		const req = await fetch('/api/contact', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});

		// tslint:disable-next-line:no-console
		console.log('req', req);

		if (!req.ok) {
			setErrorMessage(req.statusText);
			return;
		}

		setSuccessMessage(emailSuccessMessage?.Translation || '');
		return;
	};

	return (
		<section className={cls.root}>
			<article className={cls.mapSection}>
				<h2 className={cls.mapSectionTitle}>{MapTitle}</h2>
				<hr className={cls.hr} />
				<div className={cls.mapSectionMap}>
					<div className={cls.mapSectionMapInner}>
						<GoogleMaps
							lat={Coordinates.lat}
							lng={Coordinates.lng}
							googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_MAP_KEY}`}
							loadingElement={<div style={{ height: `100%` }} />}
							containerElement={<div style={{ height: `100%` }} />}
							mapElement={<div style={{ height: `100%` }} />}
						/>
					</div>
				</div>
				<div className={cls.content}>
					<div className={cls.columns}>
						<div
							className={cls.column}
							dangerouslySetInnerHTML={{ __html: ColumnTextOne }}
						/>
						<div
							className={cls.column}
							dangerouslySetInnerHTML={{ __html: ColumnTextTwo }}
						/>
						<div
							className={cls.column}
							dangerouslySetInnerHTML={{ __html: ColumnTextThree }}
						/>
					</div>
				</div>
			</article>
			<article className={cls.fromSection}>
				<form
					className={cls.form}
					onSubmit={
						// tslint:disable-next-line:jsx-no-lambda
						(ev) => handleSubmit(ev)
					}
				>
					<h4 className={cls.formTitle}>{FormTitle}</h4>
					<div className={cls.formSubtitle}>{FormSubtitle}</div>
					<label className={cls.label}>
						<span>{(salutation && salutation.Translation) || ''}</span>
						<input
							type='text'
							className={cls.input}
							name='salutation'
							ref={salutationRef}
						/>
					</label>
					<label className={cls.label}>
						<span>{(name && name.Translation) || ''}*</span>
						<input
							type='text'
							className={cls.input}
							name='name'
							ref={nameRef}
							required={true}
						/>
					</label>
					<label className={cls.label}>
						<span>{(company && company.Translation) || ''}</span>
						<input
							type='text'
							className={cls.input}
							name='company'
							ref={companyRef}
						/>
					</label>
					<label className={cls.label}>
						<span>{(email && email.Translation) || ''}*</span>
						<input
							type='email'
							className={cls.input}
							name='email'
							ref={emailRef}
							required={true}
						/>
					</label>
					<label className={cls.label}>
						<span>{(address && address.Translation) || ''}</span>
						<input
							type='text'
							className={cls.input}
							name='address'
							ref={addressRef}
						/>
					</label>
					<label className={cls.label}>
						<span>{(telephone && telephone.Translation) || ''}*</span>
						<input
							type='text'
							className={cls.input}
							name='telephone'
							ref={phoneRef}
							required={true}
						/>
					</label>
					<label className={cls.label}>
						<span>{(message && message.Translation) || ''}</span>
						<textarea
							className={cls.textarea}
							name='message'
							ref={messageRef}
						/>
					</label>
					<div className={cls.warnning}>
						<span>{(warnning && warnning.Translation) || ''}</span>
					</div>
					<button type='submit' className={cls.submitButton}>
						<span>{(sendButton && sendButton.Translation) || ''}</span>
					</button>
					{errorMessage && (
						<div className={cls.errorMessage}>{errorMessage}</div>
					)}
					{successMessage && (
						<div className={cls.successMessage}>{successMessage}</div>
					)}
				</form>
			</article>
		</section>
	);
};

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.tsx